module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/1/4-2cd012baa4de30744fa062fc98bf998d.jpg";